import clsx from 'clsx';
import PropTypes from 'prop-types';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import tourSearchInput from '../../../../helpers/selectors/tourSearchInput';
import { setIsUserInteractedWithTourList } from '../../../../store/slices/tour';
import { tourSearchRequest } from '../../../../store/slices/tripSearch';

const LoadMoreToursButton = ({ tripId, className }) => {
  const dispatch = useDispatch();
  const isTripSearch = !tripId;
  const { foundTotalTours, loadedToursCount } = useSelector(
    tourSearchInput(tripId, isTripSearch),
    shallowEqual,
  );
  const hasUserInteractedWithTourList = useSelector(
    (state) => state.tour.hasUserInteractedWithTourList,
  );
  // Both counts are catalogue-wide, so they tell that the catalogue grew but not how many of the
  // new tours pass this user's filters and dates; the banner therefore carries no number.
  const hasNewTours = (foundTotalTours || 0) > (loadedToursCount || 0);

  const handleLoadMoreTours = () => {
    dispatch(setIsUserInteractedWithTourList(false));
    dispatch(tourSearchRequest({ tripId, isTripSearch, isLoadingMore: true }));
  };

  return hasUserInteractedWithTourList && hasNewTours ? (
    <button
      className={clsx(
        'banner w-full rounded bg-progressbar text-progressbar p-2 sticky top-0 z-10 mb-2',
        className,
      )}
      type="button"
      onClick={handleLoadMoreTours}
    >
      New tours found — refresh results
    </button>
  ) : (
    <></>
  );
};

LoadMoreToursButton.propTypes = {
  tripId: PropTypes.string,
  className: PropTypes.string,
};

LoadMoreToursButton.defaultProps = {
  tripId: undefined,
  className: undefined,
};

export default LoadMoreToursButton;
